/**
 * The catalog's phone grid mode (templates/store/catalog): one or two cards
 * per row up to 480px, the visitor's choice, kept in localStorage. The
 * server cannot see it, so it always renders two cards per row.
 */
export const CATALOG_MOBILE_COLUMNS_STORAGE_KEY = "vf_mobile_columns";

/** The stored mode (1 or 2), or null when none is stored or it is unreadable. */
export const readStoredCatalogMobileColumns = (): 1 | 2 | null => {
  try {
    if (typeof localStorage === "undefined") return null;
    const stored = Number(
      localStorage.getItem(CATALOG_MOBILE_COLUMNS_STORAGE_KEY)
    );
    return stored === 1 || stored === 2 ? stored : null;
  } catch {
    return null;
  }
};
